// Animation configuration constants
export const ANIMATION_CONSTANTS = {
  // Text animation timing
  TEXT_MIN_DELAY: 8, // Minimum delay between characters (ms)
  TEXT_MAX_DELAY: 25, // Maximum delay between characters (ms)

  // AI thinking pause configuration
  THINKING_PAUSE_CHANCE: 0.05, // 5% chance to pause and "think"
  THINKING_PAUSE_MIN_DURATION: 150, // Minimum thinking pause (ms)
  THINKING_PAUSE_MAX_DURATION: 400, // Maximum thinking pause (ms)
  THINKING_TRIGGERS: ['.', '!', '?'] as const, // Characters that trigger thinking pauses

  // Fade-in animation
  FADE_IN_DISTANCE: 8, // pixels to slide up from
  FADE_IN_DURATION: '0.4s',
  FADE_IN_EASING: 'ease-out',

  // Toast notification
  TOAST_BOTTOM_OFFSET: 80, // pixels from bottom
  TOAST_ANIMATION_DURATION: 300, // ms for slide animation

  // Progressive animation
  AUTO_ADVANCE_DELAY: 100, // ms delay for non-text items
  ANIMATION_INDEX_STAGGER: 0.1, // seconds between each element
  ESTIMATED_CHARS_PER_BLOCK: 80, // rough estimate for delay calculations
  SHOW_ALL_ITEMS_INDEX: 999, // large number to show all items when animations disabled

  // Z-index layers
  Z_INDEX_TOAST: 1000,
} as const;

// Type-safe animation configuration
export type AnimationConfig = {
  minDelay: number;
  maxDelay: number;
  thinkingPauseChance: number;
  thinkingPauseMinDuration: number;
  thinkingPauseMaxDuration: number;
  thinkingTriggers: readonly string[];
};

export const DEFAULT_ANIMATION_CONFIG: AnimationConfig = {
  minDelay: ANIMATION_CONSTANTS.TEXT_MIN_DELAY,
  maxDelay: ANIMATION_CONSTANTS.TEXT_MAX_DELAY,
  thinkingPauseChance: ANIMATION_CONSTANTS.THINKING_PAUSE_CHANCE,
  thinkingPauseMinDuration: ANIMATION_CONSTANTS.THINKING_PAUSE_MIN_DURATION,
  thinkingPauseMaxDuration: ANIMATION_CONSTANTS.THINKING_PAUSE_MAX_DURATION,
  thinkingTriggers: ANIMATION_CONSTANTS.THINKING_TRIGGERS,
} as const;
